import common from '@/services/common'

export default {
  async getMashup(fileCode) {
    return (await common.execute('get', `/api/team-mashup/v1/state/${fileCode}`))
  },
  async updateMashup(mashupData) {
    return (await common.execute('post', '/api/team-mashup/v1/state', mashupData))
  },
  async promote(data) {
    return await common.execute('post', '/api/team-mashup/v1/promote', data)
  },
}
